import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M25.19 15.81A12.9 12.9 0 0 0 16 12H6.41l4.29-4.29A.996.996 0 1 0 9.29 6.3l-6 5.99a1 1 0 0 0 0 1.42l6 6c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-4.29-4.29h9.59c2.94 0 5.7 1.14 7.78 3.22s3.22 4.84 3.22 7.78c0 .55.45 1 1 1s1-.45 1-1c0-3.47-1.35-6.74-3.81-9.19z"
    />
  </svg>
);
const SvgIconArrowBendUpLeft = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconArrowBendUpLeft);
export default Memo;
